export default __webpack_public_path__ + "static/media/UM.b42567f1.svg";